import React, { useState } from 'react';
import styled from 'styled-components';
import * as taskService from '../services/taskService';

const DeleteButton = styled.button`
  background-color: rgba(255, 59, 48, 0.1);  /* Apple red with transparency */
  color: #FF3B30;  /* Apple red */
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  align-items: center;
  
  &:hover {
    background-color: rgba(255, 59, 48, 0.2);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    background-color: rgba(255, 59, 48, 0.05);
    color: rgba(255, 59, 48, 0.5);
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: #FF3B30;
  font-size: 0.8rem;
  margin-top: 0.5rem;
`;

const DeleteIcon = () => (
  <svg 
    width="16" 
    height="16" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    style={{ marginRight: '6px' }}
  >
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
);

const DeleteBoardButton = ({ boardId, boardTitle, onSuccess }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    if (!window.confirm(`Are you sure you want to delete the board "${boardTitle || 'Untitled'}"?\nThis will permanently delete all tasks in this board and cannot be undone.`)) {
      return;
    }
    
    setIsDeleting(true);
    setError(null);
    
    try {
      const result = await taskService.deleteBoard(boardId);
      
      if (result.success || !result.error) {
        console.log('Board deleted successfully');
        if (onSuccess) onSuccess(boardId);
      } else {
        setError(result.error || 'Failed to delete board');
      }
    } catch (error) {
      console.error('Error deleting board:', error);
      setError(error.message || 'Failed to delete board');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <DeleteButton onClick={handleDelete} disabled={isDeleting}>
        <DeleteIcon />
        {isDeleting ? 'Deleting Board...' : 'Delete Board'}
      </DeleteButton>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
};

export default DeleteBoardButton; 